(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('UsersListController', UsersListController);

    UsersListController.$inject = ['$stateParams', 'common', 'config', 'dataservice'];
    /* @ngInject */
    function UsersListController($stateParams, common, config, dataservice) {
        var vm = this;

        vm.title = 'Users';
        vm.displayedItems = [];
        vm.items = [];
        vm.refresh = refresh;
        vm.colorDot = colorDot;
        vm.convertUserType = convertUserType;
        vm.isLicenseValid = true;
        vm.licenseInfo = {};
        vm.unlockUser = unlockUser;
        vm.emailToUnlock = '';
        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItems(), getLicenseInfo()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                vm.isLicenseValid = vm.licenseInfo.NumberOfUsersLicensed >= vm.licenseInfo.NumberOfActiveUsers;
                return vm.licenseInfo;
            }, function (error) { });
        }

        function convertUserType(item) {
            switch (item.UserType) {
                case 0:
                    return "Standard";
                case 1:
                    return "Manager";
                case 2:
                    return "Admin";
                default:
                    return "Unknown";
            }
        }

        function getItems() {
            return dataservice.getItems('api/Users').then(function (response) {
                vm.items = vm.displayedItems = response.data;
                
                return vm.items;
            }, function (error) { });
        }

        function refresh() {
            getItems();
        }

        function colorDot(item) {
            if (item.Color) {
                return { "background-color": item.Color}
            }
            else {
                return { "background-color": "green" }
            }
        }

        function unlockUser() {
            if (vm.emailToUnlock) {
                var dto = {
                    emailToUnlock: vm.emailToUnlock
                };
                
                dataservice.saveItem('api/Tenants/UnlockUser', dto, true).then(function (response) {
                    
                    if (response.data.Success) {
                        common.logger.success("User Unlocked");
                    }
                    else {
                        common.logger.warning("User not found", null, "Warning", true);
                    }
                }, function (error) { })
            }
        }
    }
})();
